// extracted by mini-css-extract-plugin
module.exports = {"button":"LightweightCard_button__2NxBs","badge":"LightweightCard_badge__2a7wl","fullDealLabel":"LightweightCard_fullDealLabel__w-VZW"};